import { render } from "./CustomCategoryAssignFolders.vue?vue&type=template&id=a00cd13c&scoped=true&ts=true"
import script from "./CustomCategoryAssignFolders.vue?vue&type=script&lang=ts"
export * from "./CustomCategoryAssignFolders.vue?vue&type=script&lang=ts"

import "./CustomCategoryAssignFolders.vue?vue&type=style&index=0&id=a00cd13c&scoped=true&lang=css"

import exportComponent from "D:\\Ventla Code\\New Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a00cd13c"]])

export default __exports__